import { render, staticRenderFns } from "./personSchemeRentInfo.vue?vue&type=template&id=65234090&scoped=true"
import script from "./personSchemeRentInfo.vue?vue&type=script&lang=js"
export * from "./personSchemeRentInfo.vue?vue&type=script&lang=js"
import style0 from "./personSchemeRentInfo.vue?vue&type=style&index=0&id=65234090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65234090",
  null
  
)

export default component.exports